import React from "react";
import { ReactComponent as Facebook } from "../icons/facebook-f.svg";
import { ReactComponent as Instagram } from "../icons/instagram.svg";
import { ReactComponent as Github } from "../icons/github.svg";
import { ReactComponent as Linkedin } from "../icons/linkedin-in.svg";
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <h1>YASH</h1>
        <p>FOLLOW ME ON</p>
        <div className="d-flex flex-wrap w-25 justify-content-between align-items-center">
          <a
            className="facebook-icon"
            href="https://www.facebook.com/yash.purohit.1293"
          >
            <Facebook />
          </a>
          <a
            className="linkedin-icon"
            href="https://www.linkedin.com/in/yash-purohit-6b3918171/"
          >
            <Linkedin />
          </a>
          <a
            className="instagram-icon"
            href="https://www.instagram.com/yash5368/"
          >
            <Instagram />
          </a>
          <a
            className="github-icon"
            href="https://github.com/y1a2s3h4"
          >
            <Github />
          </a>
        </div>
      </div>
      <div className="footer-copyrights">
        <p className="text-center">
          Copyright &copy; {new Date().getFullYear()} All rights reserved
        </p>
      </div>
    </footer>
  );
}
